import { getUnitCookie } from "../unitCookie";
import { UnitMode } from "./UnitMode";

export interface ImperialMetricDataState {
  unitMode: UnitMode;
}

export const initialImperialMetricDataState: ImperialMetricDataState = {
  unitMode: getUnitCookie() ?? UnitMode.Metric,
};
